import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BancoPlazaService } from '../../../services/banco-plaza.service';

/**
 * Consulta el estado de liquidación BCV de una operación interbancaria.
 * Útil cuando una transacción quedó en PENDING_BCV y querés saber su estado real.
 *
 * Campo `fecha` debe ser YYMMDD (no ISO).
 */
@Component({
  selector: 'app-banco-plaza-consulta-liq-modal',
  templateUrl: './banco-plaza-consulta-liq-modal.component.html',
  styleUrls: ['./banco-plaza-consulta-liq-modal.component.sass'],
})
export class BancoPlazaConsultaLiqModalComponent implements OnInit {
  form!: FormGroup;
  loading = false;
  result: any = null;
  error: string | null = null;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<BancoPlazaConsultaLiqModalComponent>,
    private bp: BancoPlazaService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      id: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(12)]],
      cuenta: ['', [Validators.required, Validators.pattern(/^\d{20}$/)]],
      referencia: ['', [Validators.required, Validators.pattern(/^\d{8}$/)]],
      monto: ['', [Validators.required]],
      fecha: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
    });
  }

  consultar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading = true;
    this.error = null;
    this.result = null;

    this.bp.consultarLiquidacion(this.form.value).subscribe({
      next: (res) => {
        this.loading = false;
        this.result = res;
      },
      error: (err) => {
        this.loading = false;
        this.error = typeof err === 'string' ? err : 'Error consultando liquidación';
      },
    });
  }

  /**
   * Convierte una fecha del calendar (YYYY-MM-DD) a YYMMDD.
   */
  onFechaPickerChange(event: any): void {
    const val: string = event.target.value;
    if (!val) return;
    const m = val.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      const yy = m[1].slice(2);
      this.form.get('fecha')?.setValue(`${yy}${m[2]}${m[3]}`);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  get codigoLabel(): string {
    const code = this.result?.header?.codigoRespuesta;
    if (!code) return '';
    if (code === '0000') return '✅ APROBADA';
    if (code === '9999') return '⏳ PENDIENTE BCV';
    return `❌ RECHAZADA (${code})`;
  }
}
